import { render, staticRenderFns } from "./TipoRegraSelector.vue?vue&type=template&id=6e47ebd4&scoped=true"
import script from "./TipoRegraSelector.vue?vue&type=script&lang=js"
export * from "./TipoRegraSelector.vue?vue&type=script&lang=js"
import style0 from "./TipoRegraSelector.vue?vue&type=style&index=0&id=6e47ebd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e47ebd4",
  null
  
)

export default component.exports